"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationList = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const react_uid_1 = require("react-uid");
const NotificationItem_1 = __importDefault(require("./NotificationItem"));
;
const NotificationListWrapper = styled_components_1.default.div `
  @media (min-width: 1000px) {
    height: calc(100vh - 100px);
    overflow-y: auto;
    border-right: solid 1px rgba(0, 0, 0, 0.12);
    padding-right: 16px;
  }
  flex-grow: 1;
  width: 50%;

  .simple-list {
    margin-bottom: 30px;
  }

  .section-header {
    margin-bottom: 16px;
  }
`;
const NotificationList = ({ notificationGroups, checkDetails, selectedNotification, }) => (react_1.default.createElement(NotificationListWrapper, null, notificationGroups.map((group) => (react_1.default.createElement("div", { key: group.key, className: "simple-list" },
    react_1.default.createElement(Typography_1.default, { variant: "body1", className: "section-header" }, group.label.toUpperCase()),
    group.notifications.map((notification) => (react_1.default.createElement(NotificationItem_1.default, { key: (0, react_uid_1.uid)(notification), groupKey: group.key, notification: notification, checkDetails: checkDetails, selectedNotification: selectedNotification }))))))));
exports.NotificationList = NotificationList;
exports.default = (0, react_router_dom_1.withRouter)(exports.NotificationList);
